<template>
    <div>
        <az-back-button :route="{name: 'consultasListagem'}" text="Voltar para listagem"></az-back-button>
        <az-container class="pt-1">
            <div class="az-tabs">
                <v-tabs left>
                    <v-tab v-for="aba in abas" :key="aba.chave" :to="construirRota(aba.nomeRota)"
                           active-class="v-tabs__item--active secondary--text">
                        {{ aba.titulo }}
                    </v-tab>
                </v-tabs>
                <router-view></router-view>
            </div>
        </az-container>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import {actionTypes} from '@/commons/constants'

export default {
    name: 'Consultas',
    computed: {
        abas() {
            var rotas = [
                {
                    titulo: 'Dados da Licitação',
                    nomeRota: 'consultasDetalheDadosLicitacao'
                },
                {
                    titulo: 'Esclarecimento/Impugnação',
                    nomeRota: 'consultasDetalheEsclarecimentoImpugnacao'
                },
                {
                    titulo: 'Documentos Fornecedor',
                    nomeRota: 'consultasDetalheDocumentosFornecedor'
                }
            ]

            return rotas
        }
    },
    created() {
        if (this.$route.name !== 'licitacaoAtualizacaoLegadoDadosGeraisLegado') {
            this.buscarLicitacaoLegado(this.$route.params.id)
        }
    },
    methods: {
        construirRota(name) {
            return {
                name,
                params: {id: this.$route.params.id},
            }
        },
        ...mapActions([actionTypes.BUSCAR_LICITACAO_LEGADO])
    }
}
</script>